import React from "react";
import { Button, Row, Dropdown, Form} from "react-bootstrap";
import search_config from "../../assets/data/search_config.json";
import { Tooltip } from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

export function CatalogButton() {
    /**
     * When clicked, opens up a new tab to the training catalog page.
     * @returns: catalog button JSX component, linked to the training catalog page
     */

    return (
        <div className="mt-1 d-inline-block p-2">
            <a href="https://weather.ndc.nasa.gov/sport/training/catalog/" target="_blank" rel="noreferrer">
                <Button className="btn light-button-sport">Catalog</Button>
            </a>
        </div>
    );
}

export function FocusAreaDropdown(props) {
    /**
     * Component for the focus area dropdown menu. Maps over the focus area list in the search parameter JSON and creates a radio button for each one.
     * @param props: event handler function and latest focus area selection state
     * @returns: focus area dropdown JSX component
     */

    // Label prepper for ID attribute of form radio buttons
    const prepLabel = (layerName) => {
        return layerName.toLowerCase().split(" ").join("");
    };    
    
    return (
        <Dropdown className="mt-1 d-inline-block dropdown light-dropdown-sport p-2">
            <Dropdown.Toggle id="focus-dropdown" aria-haspopup="true" aria-expanded="true">Focus Areas</Dropdown.Toggle>
            <Dropdown.Menu className="px-2" aria-labelledby="focus-dropdown">
                <Form>
                    {search_config["focus_areas"].map(focusArea => (
                        <Form.Check type="radio" key={`radio-${Math.floor(Math.random() * 20000)}`} id={prepLabel(focusArea)}>
                            <Form.Check.Input type="radio" checked={props.focusArea === focusArea} onChange={() => props.focusAreaHandler(focusArea)}/>
                            <Form.Check.Label style={{whiteSpace: "nowrap"}}>{focusArea}</Form.Check.Label>
                        </Form.Check>
                    ))}
                </Form>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export function TextSearch(props) {
    /**
     * Component for the search bar, which takes input of an arbitary number of search keywords and/or phrases.
     * @param props: current query string and event handler function
     * @returns: search bar JSX component (includes the search form and tooltip icon)
     */
    
    return (
        <Row className="justify-content-center dark-bg1-sport p-2">
            <Form style={{textAlign: "center", width: "420px", padding: "0"}} onSubmit={(e) => e.preventDefault()}>
                <Form.Group className="mb-2">
                    <Form.Control type="text" placeholder="Search" value={props.query} onChange={(e) => props.queryHandler(e.target.value)}/>
                </Form.Group>
            </Form>

            <FontAwesomeIcon id="search-help" style={{width: "20px", height: "auto"}} icon={faQuestionCircle}/>
            <Tooltip anchorSelect="#search-help" place="right" content="Enter keyword(s) and/or double-quoted phrase(s)"/>
        </Row>
    );
}

export function SearchReset(props) {
    /**
     * When clicked, resets the focus area (if one is selected) and/or the text search bar (if populated).
     * @param props: event handler function
     * @returns: search resetter JSX component button
     */
    
    return (
        <div className="mt-1 d-inline-block p-2">
            <Button className="btn light-button-sport" onClick={() => props.resetTrainings()}>Reset Filters (See All Trainings)</Button>
        </div>
    );
}